
import { computed, defineComponent, PropType } from "vue";
import { DocumentStatusesEnum } from "@/store/modules/document/state";
import { getDocumentStatusLabel } from "@/utils/labels";

export default defineComponent({
  name: "DocumentStatusLabel",
  props: {
    label: {
      type: String as PropType<DocumentStatusesEnum>,
      required: true,
    },
  },
  setup(props) {
    const styleClass = computed(() => {
      let label = "tag ";
      if (props.label === DocumentStatusesEnum.NEW) {
        label += "tag--info";
      } else if (props.label === DocumentStatusesEnum.PROCESS) {
        label += "tag--processing";
      } else if (props.label === DocumentStatusesEnum.REWORK) {
        label += "tag--warning";
      } else if (props.label === DocumentStatusesEnum.SUCCESS) {
        label += "tag--success";
      } else if (
        props.label === DocumentStatusesEnum.DENIED ||
        props.label === DocumentStatusesEnum.DELETED
      ) {
        label += "tag--error";
      } else {
        label += "tag--default";
      }

      return label;
    });

    const statusLabel = computed(() => {
      return getDocumentStatusLabel(props.label);
    });

    return {
      statusLabel,
      styleClass,
    };
  },
});
